export const CARD_MODULE = 'card';
export const OUTLET_MODULE = 'outlet';
export const PAYMENT_MODULE = 'payment';

export const EWALLET_MODULE = 'ewallet';

import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState({
            metadata: state => state.meta.metadata,
        }),
    },
    methods: {
        ...mapActions('meta', ['getMetaByModule']),
        getMeta(id, module) {
            this.getMetaByModule({
                id,
                module,
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/meta.js